import { render, staticRenderFns } from "./add-sistem-manajemen.vue?vue&type=template&id=55bea54a&"
import script from "./add-sistem-manajemen.vue?vue&type=script&lang=js&"
export * from "./add-sistem-manajemen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports